import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientPersonGrid: [],
    workClientPersonAll: [],
    workClientPersonAllClient: [],
    workClientPersonShow: null,
    pageData: null,
  },
  mutations: {
    setWorkClientPersonGrid(state, payload) {
      state.workClientPersonGrid = payload
    },
    setWorkClientPersonAll(state, payload) {
      state.workClientPersonAll = payload
    },
    setWorkClientPersonAllClient(state, payload) {
      state.workClientPersonAllClient = payload
    },
    setWorkClientPersonShow(state, payload) {
      state.workClientPersonShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workClientPersonGrid: (state) => {
      return state.workClientPersonGrid
    },
    workClientPersonAll: (state) => {
      return state.workClientPersonAll
    },
    workClientPersonAllClient: (state) => {
      return state.workClientPersonAllClient
    },
    workClientPersonShow: (state) => {
      return state.workClientPersonShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkClientPersonGrid({ commit, rootState }, { limit, page, id, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain +
        '/api/admin/work/client/person/grid?limit=' +
        limit +
        '&page=' +
        page +
        '&filter[]=work_client_id:' +
        id
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=last_name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientPersonGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientPersonAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/person/grid?limit=0' +
            '&order[]=last_name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientPersonAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientPersonAllClient({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/person/grid?limit=0&filter[]=work_client_id:' +
            id +
            '&order[]=last_name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientPersonAllClient', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientPersonShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/person/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientPersonShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientPersonCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/person',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientPersonUpdate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/person',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientPersonDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/person/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
